import { FC, useCallback, useState } from 'react';
import * as S from './styles';

type CollapsibleCardProps = {
  description: string;
  header: string;
  onAccordionToggle?: (newValue: boolean) => void;
};

export const CollapsibleCard: FC<CollapsibleCardProps> = ({
  description,
  header,
  onAccordionToggle,
}) => {
  const [showCollapsible, setShowCollapsible] = useState(false);
  const onClick = useCallback(() => {
    setShowCollapsible(!showCollapsible);
    if (onAccordionToggle) {
      onAccordionToggle(!showCollapsible);
    }
  }, [showCollapsible, setShowCollapsible, onAccordionToggle]);

  return (
    <S.CollapsibleCard id={header} onClick={onClick}>
      <S.CardButton>
        {header}
        <S.Icon $collapsed={!showCollapsible} name="down" />
      </S.CardButton>
      <S.CardDescription $collapsed={!showCollapsible}>{description}</S.CardDescription>
    </S.CollapsibleCard>
  );
};
